var render, staticRenderFns
import script from "./SubTableItem.vue?vue&type=script&lang=js&"
export * from "./SubTableItem.vue?vue&type=script&lang=js&"
import style0 from "./SubTableItem.vue?vue&type=style&index=0&id=902a2164&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "902a2164",
  null
  
)

export default component.exports